"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMonetaryValueConfig = void 0;
var tax_mode_1 = require("./tax-mode");
/**
 * The default monetary value configuration.
 */
exports.defaultMonetaryValueConfig = {
    taxMode: tax_mode_1.TaxMode.Inclusive
};
//# sourceMappingURL=monetary-value.js.map